<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';

const props = defineProps<{ projectId: number | string }>();
const route = useRoute();

const tabs = computed(() => [
  { to: `/projects/${props.projectId}/forms`, label: 'Forms' },
  { to: `/projects/${props.projectId}/data`, label: 'Data' },
  { to: `/projects/${props.projectId}/analyses`, label: 'Analyses' },
  { to: `/projects/${props.projectId}/settings`, label: 'Settings' },
]);

function isActive(to: string): boolean {
  return route.path.startsWith(to);
}
</script>

<template>
  <nav class="projects-sub-nav">
    <ul class="projects-sub-nav__list">
      <li v-for="t in tabs" :key="t.to">
        <RouterLink :to="t.to" :class="['projects-sub-nav__link', { 'is-active': isActive(t.to) }]">
          {{ t.label }}
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.projects-sub-nav {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.projects-sub-nav__list {
  display: flex;
  gap: 1.5rem;
  list-style: none;
  margin: 0 auto;
  padding: 0.5rem 1.5rem;
  max-width: 60rem;
}
.projects-sub-nav__link {
  color: #4b5563;
  text-decoration: none;
  font-weight: 500;
}
.projects-sub-nav__link.is-active {
  color: #2563eb;
  text-decoration: underline;
}
</style>
